import lightboxControlVideo from './lightboxControlVideo';
const $ = jQuery.noConflict();

const resetIframeOnSlideChange = () => {
    const resetIframe = () => {
        const currentIframe = $(
            '.slick-current .video-button-container.video-play iframe'
        );
        if (currentIframe.length > 0) {
            lightboxControlVideo.stop(currentIframe);
        }
    };

    $('.block-media-gallery .gallery-slider').on('beforeChange', resetIframe);
    $('.block-media-gallery .lightbox-gallery__close').on('click', resetIframe);
};

export default resetIframeOnSlideChange;
